import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../../service/service.module';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

@Injectable({
  providedIn: 'root',
})
export class ChatNotifyService {

  connection: any;
  environment = EnvironmentService.environment;

  constructor(public http: HttpClient) {
  }

  createConnection() {
    this.connection = new HubConnectionBuilder()
      .configureLogging(LogLevel.Information)
      .withUrl(this.environment.messagingHubUrl)
      .build();
  }

  connect() {
    this.connection
      .start()
      .then(function () {
      })
      .catch(function (err: any) {
        return console.error();
      });
  }

  stop() {
    this.connection.stop()
      .then(function () {
      })
      .catch(function (err: any) {
        return console.error();
      });
  }

}
